/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWatchlistCommand } from '../../models/create-watchlist-command';
import { WatchlistModelResult } from '../../models/watchlist-model-result';

export interface ApiWatchlistCreatePost$Plain$Json$Params {
      body?: CreateWatchlistCommand
}

export function apiWatchlistCreatePost$Plain$Json(http: HttpClient, rootUrl: string, params?: ApiWatchlistCreatePost$Plain$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<WatchlistModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistCreatePost$Plain$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'text/plain');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WatchlistModelResult>;
    })
  );
}

apiWatchlistCreatePost$Plain$Json.PATH = '/api/watchlist/create';
